import React from "react";
import Helmet from "react-helmet";
import { graphql } from "gatsby";

import PagesTemplate from "./_template";

export const query = graphql`
  {
    site {
      siteMetadata {
        siteTitle
        loginLink
        signupLink
      }
    }
  }
`;

export default class RequestADemo extends React.Component {
  componentDidMount() {
    var schedulingScript = document.createElement("script");
    schedulingScript.setAttribute(
      "src",
      "https://calendly.com/assets/external/widget.js"
    );
    document.body.appendChild(schedulingScript);
  }

  render() {
    return (
      <PagesTemplate>
        <div>
          <Helmet
            title={`Request a Demo | ${this.props.data.site.siteMetadata.siteTitle}`}
            meta={[
              {
                name: "description",
                content:
                  "Request a private demo of O3 and see how it can benefit your business",
              },
              {
                name: "keywords",
                content:
                  "O3, perspexi labs, business analytics, customer satisfaction, customer experience, text message surveys, digital health, patient satisfaction, outcome measures",
              },
            ]}
          />

          <div className="mw8 center pt4 pb3 ph3 cf">
            <h1 className="f2 lh-title">It&apos;s Demo Time</h1>

            <p className="f5 lh-copy">
              We know that seeing is believing, and we&apos;d love to schedule a
              free demo with you to show you exactly how O3 works and talk about
              how it will benefit your business.
            </p>
            <p className="f6 lh-copy">
              The demo takes less than 30 minutes, and you can get started right
              away. Schedule the most convenient time for you below.
            </p>

            <div
              className="calendly-inline-widget"
              data-url="https://calendly.com/o3powered/outreach-demo"
              style={{ minWidth: 320, height: 580 }}
            />
          </div>
        </div>
      </PagesTemplate>
    );
  }
}
